export const formatDate = (isoString) => {
  if (!isoString) return "Fecha inválida";

  const date = new Date(isoString);
  if (isNaN(date.getTime())) return "Fecha inválida";

  const pad = (n) => n.toString().padStart(2, "0");

  const day = pad(date.getDate());
  const month = pad(date.getMonth() + 1);
  const year = date.getFullYear();
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());

  return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};
